function EnquiryForm() {

    var self = this;

    this.$country = document.querySelector('#contact_country');
    this.$scandanavianOption = document.querySelector('#scandanavian-option');
    this.$confirmLabel = document.querySelector('#js-confirm-label');
    this.$referer = document.querySelector('#contact_referer');

    this.init = function() {
        this.watchCountryOptions();
        this.watchRefererOptions();
    };

    this.watchCountryOptions = function() {
        if (!this.$country) {
            return;
        }
        this.$country.onchange = function() {
            if (self.$scandanavianOption !== null && self.$confirmLabel !== null) {
                if ((this.value === 'NO') || (this.value === 'SE')) {
                    self.$scandanavianOption.classList.remove('d3r-hidden');
                    self.$confirmLabel.innerHTML = 'Please specify that you are one of the below and a professional investor<span> *</span>';
                } else {
                    self.$scandanavianOption.classList.add('d3r-hidden');
                    self.$confirmLabel.innerHTML = 'Please specify that you are one of the below<span> *</span>';
                }
            }
        };

        this.$country.onchange();
    };

    this.watchRefererOptions = function() {
        if (!this.$referer) {
            return;
        }
        this.$referer.onchange = function() {
            var el = this;
            var loop = new Loop();
            var methods = {
                'Members Referral': '#referer_other_wrap',
                'Email': '#referer_detail_wrap',
                'Event': '#referer_detail_wrap',
                'Press Feature': '#referer_detail_wrap',
                'Other': '#referer_detail_wrap',
                'Referral': '#referer_other_wrap',
            };

            loop.array(document.querySelectorAll('.hide'), function(array, i) {
                array[i].classList.add('d3r-hidden');
            });

            if (!!methods[el.value]) {
                document.querySelector(methods[el.value]).classList.remove('d3r-hidden');
            }
        };

        this.$referer.onchange();
    }
}
